import { FormattedMessage } from 'react-intl';
import React from 'react';
import { BATCHES_ARCHIVED_VIEW_ID, BATCHES_VIEW_ID } from './view-id-constants';

export const BatchesArchived = {
  label: <FormattedMessage defaultMessage='Archived' description='ordersPage.nav.archivedBatches' id='yAbrQk' />,
  id: BATCHES_ARCHIVED_VIEW_ID,
  navigationOverride: '/shipments/batches/archived',
  parentId: BATCHES_VIEW_ID,
};
